import * as React from "react";
function SvgStory(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M18.8 29.2c-3.1.6-6.2.2-9-1.2-.5-.3-1.1-.1-1.4.4s-.1 1.1.4 1.4c3.2 1.7 6.9 2.2 10.4 1.4.6-.1.9-.7.8-1.2s-.7-.9-1.2-.8m-15-7.3c-.4-.8-.7-1.6-.9-2.5-.1-.6-.7-.9-1.3-.7-.6.1-.9.7-.7 1.3.7 2.6 2.1 5.1 4.1 7.1.2.2.5.3.7.3.6 0 1-.4 1.1-.9 0-.3-.1-.7-.4-.9-1-1.1-1.9-2.3-2.6-3.7M30 9.2C27.4 3.8 22 .4 16 .5c-.6 0-1 .5-1 1s.5 1 1 1c5.2 0 9.9 2.9 12.1 7.6 3 6.3.7 13.9-5.2 17.5-.5.1-.8.7-.7 1.2.1.5.7.8 1.2.7.2 0 .4-.1.5-.1 7-4.2 9.6-12.9 6.1-20.2M1.5 15.3c.5 0 1-.4 1-.9.2-1.3.5-2.5 1-3.7.2-.5 0-1.1-.5-1.4s-1.1 0-1.4.5a13 13 0 00-1.1 4.3c-.1.5.3 1.1.8 1.2h.2M6.2 4.2c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1M16 17.5c-2.6 0-4.8-2.1-4.8-4.8S13.4 8 16 8c2.6 0 4.8 2.1 4.8 4.8s-2.2 4.7-4.8 4.7zm0-7.5c-1.5 0-2.8 1.2-2.8 2.8s1.2 2.8 2.8 2.8 2.8-1.2 2.8-2.8S17.5 10 16 10zm6.9 14h-4.3v-2h2.2a4.93 4.93 0 00-8.3-2.5c-.7.7-1.1 1.5-1.3 2.5h2.2v2H9.1v-1a6.8 6.8 0 016.9-6.9c3.8 0 6.9 3.1 6.9 6.9v1z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgStory);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
